/* eslint-disable no-unused-expressions */
import React, { useEffect, useContext } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Alert from 'react-s-alert';
import _ from 'lodash';
import AlertTemplate from 'modules/common/components/AlertTemplate';
import Marker from 'modules/common/components/Alert';
import Modal from 'modules/common/components/Modal';
import { ModalProvider } from 'modules/common/components/DrawerModal';
import LoginContainer from 'modules/auth/containers/LoginContainer';
import ForgotPass from 'modules/auth/containers/ForgotPassword';
import withAuth from 'modules/auth/hoc/withAuth';
import PrivateRoutes from 'PrivateRoutes';
import * as commonAction from 'modules/common/actions';
import OtpContainer from 'modules/auth/containers/OtpContainer';
import CmsContext from './context/CmsContext';

import cmsColors from './cmsThemes/cmsColors'

const HeaderComponent = () => {
  const cmsContext = useContext(CmsContext);
  const CMS_FAVICON = cmsContext.findByType('LOGOS');
  const CMS_COLORS = cmsContext.findByType('COLORS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const CMS_BACKGROUNDS = cmsContext.findByType('BACKGROUNDS');

  // Accessing scss variable "--cms-primary" using plain JavaScript and update default value based on cms
  const root = document.documentElement;

  root?.style.setProperty("--cms-primary", _.get(CMS_COLORS, "primary_color"));
  root?.style.setProperty("--cms-primary-light", _.get(CMS_COLORS, "primary_color_light"));
  root?.style.setProperty("--cms-secondary", _.get(CMS_COLORS, "cms_secondary"));
  root?.style.setProperty("--cms-muted", _.get(CMS_COLORS, "muted_color"));
  root?.style.setProperty("--cms-muted-secondary", _.get(CMS_COLORS, "muted_secondary_color"));
  root?.style.setProperty("--cms-light", _.get(CMS_COLORS, "light_color"));
  root?.style.setProperty("--cms-danger", _.get(CMS_COLORS, "danger_color"));

  return (
    <Helmet
      defer={false}
      style={[
        {
          cssText: `   
            ${cmsColors(CMS_COLORS)}

            .login-background--core {
              background-image: 
                linear-gradient(180deg, rgba(0, 37, 87, 0.8) 0%, rgba(55, 103, 190, 0.8) 100%), 
                url("${_.get(CMS_BACKGROUNDS, 'CORE_BACKGROUND.cdnUrl')}") !important;
            }
          `,
        },
      ]}
    >
      <link
        id="favicon"
        rel="icon"
        href={`${_.get(CMS_FAVICON, 'FAVICON.cdnUrl')}`}
        type="image/x-icon"
      />
      <title>{_.get(CMS_VARIABLES, "TITLE")}</title>
    </Helmet>
  );
};

export const ModalContext = React.createContext(() => { });
function App({ auth, modal, setModal, getCms, cmsList }) {
  const onCloseModal = () => {
    setModal({
      isOpen: false,
      content: null,
      title: '',
    });
  };

  const isAuthenticated = _.get(auth, 'item.isAuthenticated');

  const findByType = type => {
    const isExist = cmsList.find(
      item => _.get(item, 'attributes.type') === type
    );
    if (isExist) return JSON.parse(_.get(isExist, 'attributes.body'));
    return {};
  };

  useEffect(() => {
    getCms();
  }, [isAuthenticated]);

  useEffect(() => {
    // close all modal if token expires
    if (isAuthenticated === false || _.isNull(_.get(auth, "item.token"))) {
      setModal({
        isOpen: false,
        content: null,
        title: '',
      });
    }
  }, [isAuthenticated, _.get(auth, "item.token")])

  return (
    <>
      <CmsContext.Provider
        value={{
          data: cmsList,
          findByType,
        }}
      >
        {/* <Helmet>
          <link
            id="favicon"
            rel="icon"
            href="/new-favicon.ico"
            type="image/x-icon"
          />
        </Helmet> */}
        <HeaderComponent />
        <ModalContext.Provider value={setModal}>
          <ModalProvider>
            <Switch>
              {isAuthenticated && <Route path="/" component={PrivateRoutes} />}
              <Route path="/forgot-password" component={ForgotPass} />
              <Route path="/change-password" component={OtpContainer} />
              <Route path="/" component={LoginContainer} />
            </Switch>
            <Marker />

            <Modal key="modal-component" data={modal} onClose={onCloseModal}>
              {_.get(modal, 'content')}
            </Modal>
            <Alert
              key="alert"
              stack={{ limit: 1 }}
              effect="slide"
              contentTemplate={AlertTemplate}
            />
          </ModalProvider>
        </ModalContext.Provider>
      </CmsContext.Provider>
    </>
  );
}

App.propTypes = {
  auth: PropTypes.instanceOf(Object).isRequired,
  modal: PropTypes.instanceOf(Object).isRequired,
  setModal: PropTypes.instanceOf(Function).isRequired,
  getCms: PropTypes.instanceOf(Function).isRequired,
  cmsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ modal, api }) => ({
  modal,
  cmsList: _.get(api, 'CMS.list') || [],
});

const enhance = _.flowRight([
  withAuth,
  withRouter,
  connect(mapStateToProps, commonAction),
]);

export default enhance(App);
